import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';

import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { DivisionService } from '../../services/division.service';
import { Division } from '../../models/division';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { ParentDepartment } from '../../models/parentdepartment';
import { ParentDepartmentService } from '../../services/parentdepartment.service';
@Component({
  selector: 'app-parentdepartment',
  templateUrl: './parentdepartment.component.html',
  styleUrls: ['./parentdepartment.component.css']
})
export class ParentdepartmentComponent implements OnInit {

    @ViewChild('view') view!: TemplateRef<any>;
    @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
    private unsubscribe$: Subject<void> = new Subject<void>();
    headerDepartment: PageHeader;
    entity: ParentDepartment = new ParentDepartment();
    selectedDepartment: ParentDepartment = new ParentDepartment();
    editingEntity: ParentDepartment = new ParentDepartment();
    departments: any;
    departmentColumns: any[]=[];
    listView: boolean = true;
    formCaption: string = ''; 
    employees: Array<Employee> = [];
    selectedEmployee: any;
    emailcheck: boolean = true;
    defaultPageSize: number;
    pageSkip: number = 0;
    pageSizes: any = [];
    defaultRowsCount: number;
    saveDisabled: boolean = false;
    company: Array<Company> = [];
    selectedCompany: any;
    divisions: Array<Division> = [];
    selectedDivision: any;
    locations: Array<Location> = [];
    selectedLocation: any;
    codeCheck: boolean = true;
    codealCheck: boolean = true;
    opened: boolean = false;
    details: any;
    constructor(
      private _departmentService: ParentDepartmentService, 
      private _employeeService: EmployeeService,
      private _divisionService: DivisionService,
      private _companyService: CompanyService,
      private _locationService: LocationService,
      private _coreSaveService: CoreSaveService,
      private configService: ConfigService,
      private messageService: MessageService,
      private notification: NotificationsService,
    ) {
      this.headerDepartment = this.initPageHeader();
      this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
      this.pageSizes = this.configService.getConfigValue('pageSizes');
      this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
      this.departments = [];
      this.getAllDepartment();
    }
    ngAfterViewInit(): void {
      this.departmentColumns = [
        { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
        { field: "ParentDepartmentName", title: 'Parent Department', filter: true, sortable: true, width: 150 },
        { field: "ParentDepartmentCode", title: 'Code', filter: true, sortable: true, width: 100 },
        { field: "ParentDepartmentMail", title: 'Email Id', filter: true, sortable: true, width: 100 },
        { field: "ParentDepartmentPhone", title: 'Phone', filter: true, sortable: true, width: 100 },
        { field: "EmployeeName", title: 'Head', filter: true, sortable: true , width: 100},
        { field: "Active", title: 'Active', filter: false, sortable: true , width: 100},
        { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
      ];
    }
  
     
    onPaginationChange(event: any) {
      if (this.defaultPageSize != event.take) {
        this.defaultPageSize = event.take;
      }
      this.pageSkip = event.skip;
      this._departmentService.getAllParentDepartment('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<ParentDepartment>) => {
        this.departments = {
          data: entities,
          total: entities[0] ? entities[0].TotalCount : 0
        }
      });
    }
    getAllCompany(filter: string) {
      this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
        this.company = data;
      })
    }
    getAllDivisions(filter: string) {
      this._divisionService.getAllDivisions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Division>) => {
        this.divisions = data;
      })
    }
    getAllLocations(filter: string) {
      this._locationService.getAllLocations(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Location>) => {
        this.locations = data;
      })
    }
    getAllEmployees(filter: string) {
      this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
        this.employees = data;
      })
    }
    onFilterChange(event: any): void {
      if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
        var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
        //1 for gridfilter type
        this._departmentService.getAllParentDepartment(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((departments: Array<ParentDepartment>) => {
          this.departments = {
            data: departments,
            total: departments[0] ? departments[0].TotalCount : 0
          }
        });
      }
    }
    getAllDepartment() {
      this._departmentService.getAllParentDepartment('', Number(this.defaultPageSize), 1, 0, 0).subscribe((departments: Array<ParentDepartment>) => {
        this.departments = {
          data: departments,
          total: departments[0] ? departments[0].TotalCount : 0
        }
      })
    };
  
    ngOnInit(): void {
      this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
        if (message?.eventName === 'delete_read_confirmation') {
          if (message?.param.action === "FA") {
            this._departmentService.deleteParentDepartment(this.selectedDepartment.ParentDepartment_Id).subscribe((entity: any) => {
              this.notification.showSuccess('Deleted Successfully');
              this.clearDepartment();
              this.getAllDepartment();
            },
            )
          }
        }
      });
    }
  
    initPageHeader(): PageHeader {
      let headerDepartment = new PageHeader();
      headerDepartment.PageCaption = "Parent Department";
      headerDepartment.IconClass = "bi bi-shield-shaded";
      return headerDepartment;
    }
  
    deleteDepartment(event: any) {
      if (event.seletedRows[0]) {
        this.selectedDepartment.ParentDepartment_Id = event.seletedRows[0];
        var message: ICommonMessage = {
          eventName: "showDialog",
          param: {
            content: "Do you want to delete this entry ?",
            caption: "Parent Department",
            returnKey: "delete_read_confirmation"
          }
        };
        this.messageService.sendCommonMessage(message);
      }
    }
  
    addDepartment(event: any) {
      this.listView = false;
      this.clearDepartment();
      this.getAllCompany('');
      this.getAllDivisions('');
      this.getAllLocations('');
      this.getAllEmployees('');
      this.formCaption = "Add Parent Department";
    }
  
    editDepartment(event: any): void {
      if (event.seletedRows[0]) {
        this._departmentService.viewParentDepartment(event.seletedRows[0]).subscribe((departments: Array<ParentDepartment>) => {
          let editEnity = departments[0] ? departments[0] : new ParentDepartment();
          if (editEnity) {
            this.editingEntity = editEnity;
            this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
            this.selectedDivision = { Division_Id: editEnity.Division_Id, DivisionName: editEnity.DivisionName };
            this.selectedLocation = { Location_Id: editEnity.Location_Id, LocationName: editEnity.LocationName };
            this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };
            this.entity = { ...this.editingEntity };
  
            this.listView = false;
            this.formCaption = "Edit Parent Department";
            this.getAllCompany('');
            this.getAllDivisions('');
            this.getAllLocations('');
            this.getAllEmployees('');
            this.entity.EntityMetaData = [
              { FieldName: 'ParentDepartmentName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Parent Department Name is required' },
              //{ FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' },
              { FieldName: 'ParentDepartmentCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
              { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Email is required' },
              { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Phone is required' },
              { FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Parent Department Head is required' },
            ];
          }
        });
      }
    }
  
    save(event: any): void {
      if(parseInt(this.entity.ParentDepartmentCode)==0)
    {
      this.notification.showWarning('zero not allowed');
      return
    }
      this.saveDisabled = true;
      let validations = this._coreSaveService.saveValidation(this.entity);
      if (validations.length === 0) {
        this._departmentService.checkDuplication(this.entity.ParentDepartment_Id,this.entity.ParentDepartmentCode).subscribe((res) => {
          if (res.Success === false) {
            this.notification.showWarning('Parent Department Code already exists');
            this.saveDisabled = false;
          }
          else {
            if (this.entity.Phone.length != 0 && this.entity.Phone.length != 10) {
              this.notification.showWarning("Invalid Phone No.");
              this.saveDisabled = false;
            }
  
            // const re = /^(0*[1-9]+0*)+$/;
            // ceonst real=/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
            // this.codeCheck = re.test(String(this.entity.ParentDepartmentCode).toString());
            // this.codealCheck = real.test(String(this.entity.ParentDepartmentCode).toString());
            // if (this.codealCheck == false&&this.codeCheck==false ) {
             
            //   this.notification.showWarning("Invalid code ");
            //   this.saveDisabled = false;
              
            // }
            else {
              if (this.entity.EmailId != "") {
                // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; commented on 04-06-2024 by jessil for #I238
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
                if (this.emailcheck === false) {
                  this.notification.showWarning("Email not valid");
                  this.saveDisabled = false;
                  return;
                }}
                  this._departmentService.checkEmail(this.entity.EmailId, this.entity.ParentDepartment_Id).subscribe((response) => {
                    if (response.Success == false) {
                      this.notification.showWarning("Email already exists");
                      this.saveDisabled = false;
                      return;
                    }
                    else {
                      this._departmentService.saveParentDepartment(this.entity).subscribe(() => {
                        if (this.entity.ParentDepartment_Id == '00000000-0000-0000-0000-000000000000') {
                          this.notification.showSuccess('Saved Successfully');
                        }
                        else {
                          this.notification.showSuccess('Updated Successfully');
                        }
                        this.listView = true;
                        this.clearDepartment();
                        this.getAllDepartment();
                      })
                    }
                  });
                }
              }
        });
      }
      else {
        this.saveDisabled = false;
      }
  
    }
    goToBackTab(): void {

      this.listView = true;
  
    }
    AlphabetsOnly(event: any): boolean {
      var inp = String.fromCharCode(event.keyCode);
      if (/^[a-zA-Z\s]*$/.test(inp)) {
        return true;
      } else {
        return false;
      }
  
    }
  
    gotoBack(): void {
      this.listView = true;
      this.getAllDepartment();
    }
  
    refreshDepartments(event: any): void {
      this.departments=[];
      this.getAllDepartment();
    }
  
    clearDepartment(): void {
      this.selectedLocation = {}; 
      this.selectedCompany = {}; 
      this.selectedDivision = {}; 
      this.entity = new ParentDepartment();
      this.saveDisabled = false;
      this.selectedEmployee="";
      }
  
    onExcelExport() {
      this.excelexport.save()
    }
  
    revertChanges(): void {
      this.entity = { ...this.editingEntity };
    }
  
    numberOnly(event: any): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
  
    ngOnDestroy(): void {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }
    public close() {
      this.opened = false;
    }
    public open(dataItem: any): void {
   this.entity.ParentDepartment_Id=dataItem.ParentDepartment_Id;
   this.details =[];
   this._departmentService.viewParentDepartment(this.entity.ParentDepartment_Id).subscribe((departments: Array<ParentDepartment>) => {
    this.opened = true;
    this.details = departments[0];
    })}
  
  }
